export const parseFirebaseInFilterValue = (value: any[]) => {
  if (!value?.length) {
    return [""];
  }
  return value;
};
